import { DashboardModule, Link } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useCustomDeadline'

import type { UseCustomDeadlinesPayload } from '@hooks/useCustomDeadlines'

import type { AgencyModel } from '@models/types'

import CustomDeadlineListItem from '@components/CustomDeadlineListItem'

type CustomDeadlineProps = {
  customDeadlines: UseCustomDeadlinesPayload['filteredCustomDeadlines'],
  selectedAgency: AgencyModel,
}

const Deadlines = (props: CustomDeadlineProps) => {
  const {
    customDeadlines,
    selectedAgency,
  } = props

  const { customDeadlinesIndexUrl } = generateUrls({}, { prefixRoute: `agencies/${selectedAgency.id}/manage` })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <Link
          href={customDeadlinesIndexUrl}
          textProps={{ fontSize: 'xsmall' }}
        >
          Manage
        </Link>
        )}
      title="Custom Deadlines"
    >
      {customDeadlines.map(customDeadline => (
        <CustomDeadlineListItem
          customDeadline={customDeadline}
          key={customDeadline.id}
        />
      ))}
    </DashboardModule>
  )
}

export default Deadlines
